import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Text from '../../../../shared/Text';
import { TileCard } from './TileCard.jsx';

export const PostPreview = ({ tiles }) => {
  const { t } = useTranslation('postNotifications');

  return (
    <Wrapper>
      <Text variant="h6">{t('reviewStep.postPreview')}</Text>
      <Posts>
        {tiles.map(tile => (
          <TileCard key={tile.uuid} tile={tile} />
        ))}
      </Posts>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  padding: 16px;
  margin: 20px;
  display: grid;
  gap: 8px;
`;

const Posts = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
`;
